import PageLayout from '../../layouts/pagesLayouts/PageLayout'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import ViewSaldo from './viewSaldo/ViewSaldo'
import ViewConsumption from './viewConsumption/ViewConsumption'
import ViewComparison from './viewComparison/ViewComparison'
import useIsMobile from '../../utils/useIsMobile'
import ViewComparisonByYear from './viewComparisonByYear/ViewComparisonByYear'
import { useState } from 'react'
import ViewComparisonByYearPrice from './viewComparisonByYear/ViewComparisonByYearPrice'
import useRolePage from '../../utils/useRolePage'
import { hasRoleAccess } from '../../utils/roles'


const AnalyticsPage = () => {

    const { data: roles } = useRolePage();

    const { t } = useTranslation()

    const isMobile = useIsMobile(1200, false)

    const [activeDateCommon, setActiveDateCommon] = useState<any>(null);

    return (
        <PageLayout>
            <Helmet>
                <title>
                    {t('analytics.analytics_title')}
                </title>
            </Helmet>
            {
                hasRoleAccess('analytics', roles) ?
                    <div className='flex flex-col gap-[48px] lap:gap-[96px] des:gap-[128px]'>
                        {
                            hasRoleAccess('analytics.saldo', roles) ?
                                <ViewSaldo
                                    activeDateCommon={activeDateCommon}
                                    setActiveDateCommon={setActiveDateCommon}
                                />
                                :
                                <></>
                        }
                        {
                            hasRoleAccess('analytics.consumptions', roles) ?
                                <ViewConsumption
                                    activeDateCommon={activeDateCommon}
                                    isMobile={isMobile}
                                />
                                :
                                <></>
                        }
                        {
                            hasRoleAccess('analytics.price_comparison', roles) ?
                                <ViewComparisonByYear
                                    activeDateCommon={activeDateCommon}
                                    isMobile={isMobile}
                                />
                                :
                                <></>
                        }
                        {
                            hasRoleAccess('analytics.price_comparison', roles) ?
                                <ViewComparisonByYearPrice
                                    activeDateCommon={activeDateCommon}
                                    isMobile={isMobile}
                                />
                                :
                                <></>
                        }
                        {
                            hasRoleAccess('analytics.change', roles) ?
                                <ViewComparison isMobile={isMobile} />
                                :
                                <></>
                        }
                    </div>
                    :
                    <></>
            }
        </PageLayout>
    )
}

export default AnalyticsPage
